import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { REGISTER, ROOT, PASSWORD_RESET, LOGIN } from '../../../constants/routes';
import formik from './PasswordResetForm';
import Loader from '../../../components/Loader';
import { useFormik } from 'formik';
import logo from '../../../images/logo.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../../../reducers/auth/auth.selectors';
import { Form, FormControl, InputGroup, Modal } from 'react-bootstrap';
import { EmailIcon, UserIcon } from '../../../components/Icons';
import FooterLinks from '../FooterLinks';
import { Dropdown } from 'react-bootstrap';
import LoginRegisterHeader from '../../../components/generic-components/LoginRegisterHeader';
import LoginTermsAndConditions from '../../../components/generic-components/LoginTermsAndConditions';
import LanguageSwitcher from '../../../components/generic-components/LanguageSwitcher';
import ButtonComponent from '../../../components/generic-components/ButtonComponent';
import { LanguageArrow } from '../../../components/Icons';
import API from '../../../API';
const PasswordReset = ({ history }) => {
  const [languagesData, setLanguagesData] = useState([]);

  const handleItemSelect = item => {
    let current_language = localStorage.getItem('current_language');
    if (current_language === item.id) return;
    if (item.id === 'he') {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    localStorage.setItem('current_language', item.id);
    i18n.changeLanguage(item.id.toLowerCase());
  };

  const user = useSelector(selectAuthUser);
  const isHebrew = localStorage.getItem('current_language') === 'he';
  const { t, i18n} = useTranslation();
  useEffect(() => {
    if (user) history.push(ROOT);
  }, []);
  const { values, status, handleSubmit, errors, touched, handleChange, isSubmitting } = useFormik(
    formik({
      history,
    })
  );

  useEffect(() => {
    const fetchCountries = () => {
      API.get(`languages`).then(res => {
        setLanguagesData(res);
      });
    };
    fetchCountries();
  }, []);

  return (
    <div className="d-flex flex-column flex-fill pt-4 pb-5 no-repeat flex-fill padding-box background_dark register-container">
      <LoginRegisterHeader />

      <form className="login-form" onSubmit={handleSubmit}>
        <div className={'my-2 reset-password-desc'}>
          <p className={`text-lightPurple font-size-12 check-your-email`}>{t('PASSWORD_RESET_LINK')}</p>
        </div>

        <Loader isLoadin={isSubmitting} height={237} size={60}>
          <div className="d-flex flex-column mx-auto w-100 align-items-center ">
            {status &&
              status.errors &&
              status.errors.map((err, key) => (
                <p key={key} className="text-danger text-center">
                  {err}
                </p>
              ))}
            <React.Fragment>
              {status && status.success && (
                <p className="text-yellow check-your-email w-100 mb-1" style={{ fontSize: '0.75rem', textAlign: 'left' }}>
                  {t('Check your email!')}
                </p>
              )}
              <Form.Group className="w-100 ">
                <InputGroup size="lg">
                  <FormControl
                    type="email"
                    className="input-field input-login"
                    id="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    placeholder={t('Enter Email Address')}
                    isInvalid={touched.email && errors.email}
                  />
                  <Form.Control.Feedback type="invalid" tooltip>
                    {!!errors.email && t(errors.email)}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <ButtonComponent
                btnText={t('reset_password')}
                transparent={false}
                customClass={'mt-5 mb-3 btn-gradient custom-sign-in-btn'}
              />
            </React.Fragment>

            <p className={'text-lightPurple sign-up-here mt-2 font-size-12'}>{t('Already have an account')}</p>

            <p className={'log-in-here text-white mt-2'}>
              <Link to={LOGIN} className="font-weight-bold">
                {t('Sign in')}
              </Link>
            </p>
          </div>
        </Loader>
      </form>

      <LoginTermsAndConditions />
      <div className='language-picker' >
        <Dropdown>
          <Dropdown.Toggle>
            {localStorage.getItem('current_language') &&
              Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
              ? t(Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')).name)
              : 'English'}
            <div className='language-arrow'>
              <LanguageArrow />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.values(languagesData).map(language => (
              <Dropdown.Item onClick={() => handleItemSelect(language)}>
                <label className="container">
                  <input
                    type="radio"
                    checked={
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')) &&
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
                        .name === language.name
                    }
                    name="radio"
                  />
                  <span className="checkmark"></span>
                </label>
                {t(language.name)}
              </Dropdown.Item>
            ))}
            <div className="shape"></div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default PasswordReset;
